"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("./IconBox.css");
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
    Icon box
    
    An icon box with that returns 
    multiple icons with onclick actions

    Verified by: Yorben Verhoestest
    Date: 04/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/

// Our main component
var IconBoxElement = function IconBoxElement(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "iconBox"
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, item.render( /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      className: "iconBoxIcon ".concat(item.active ? 'active' : ''),
      name: item.icon,
      onClick: function onClick() {
        return item.onClick ? item.onClick() : undefined;
      },
      title: item.name
    })));
  }));
};
var _default = IconBoxElement;
exports["default"] = _default;